var map = {
	"./gs/NewUi": 925,
	"./gs/NewUi.js": 925,
	"./gs/OldUi": 926,
	"./gs/OldUi.js": 926,
	"./spireon/SpireonNew": 927,
	"./spireon/SpireonNew.js": 927,
	"./spireon/SpireonOld": 928,
	"./spireon/SpireonOld.js": 928
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2668;